module.exports = __webpack_public_path__ + "img/steelframing.5d6693e2.webp";